import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: '首页',
    component: () => import('@/views/home/index.vue'),
  },
  {
    path: '/test',
    name: '首页',
    component: () => import('@/views/test'),
  },
  {
    path: '/customer_home',
    name: '首页',
    component: () => import('@/views/customer_home/index.vue'),
  },
  {
    path: '/customer_home/customer_data',
    name: '病例数据',
    component: () => import('@/views/customer_data/index.vue'),
  },
  {
    path: '/case_consult',
    name: '病例咨询',
    component: () => import('@/views/case_consult/index.vue'),
  },
  {
    path: '/notice_center',
    name: '通知中心',
    component: () => import('@/views/notice_center/index.vue'),
  },
  {
    path: '/notice_center/publish_notice',
    name: '发布通知',
    component: () => import('@/views/notice_center/publish_notice.vue'),
  },
  {
    path: '/sales_home',
    name: '首页',
    component: () => import('@/views/sales_home/index.vue'),
  },
  {
    path: '/sales_custom',
    name: '客户列表',
    component: () => import('@/views/sales_custom/index.vue'),
  },
  {
    path: '/sales_custom/visit_records',
    name: '走访记录',
    component: () => import('@/views/sales_custom/visit_records.vue'),
  },
  {
    path: '/sales_data',
    name: '我的数据',
    component: () => import('@/views/sales_data/index.vue'),
  },
  {
    path: '/supplier_home',
    name: '首页',
    component: () => import('@/views/supplier_home/index.vue'),
  },
  {
    path: '/technician_home',
    name: '首页',
    component: () => import('@/views/technician_home/index.vue'),
  },
  {
    path: '/doctor',
    name: '学员列表',
    component: () => import('@/views/doctor/index.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/chat/index.vue')
  },
  {
    path: '/case_management',
    name: '病历管理',
    component: () => import('@/views/case_management/index.vue')
  },
  {
    path: '/mentor_case_management',
    name: '导师病历管理',
    component: () => import('@/views/case_management/mentor_index.vue')
  },
  {
    path: '/case_management/add_case',
    name: '新增病例',
    component: () => import('@/views/case_management/add_case.vue')
  },
  {
    path: '/case_management/big_case',
    name: '大病案',
    component: () => import('@/views/case_management/big_case.vue')
  },
  {
    path: '/case_management/add_card',
    name: '新增资料卡',
    component: () => import('@/views/case_management/add_card.vue')
  },
  {
    path: '/case_management/edit_card',
    name: '编辑资料卡',
    component: () => import('@/views/case_management/edit_card.vue')
  },
  {
    path: '/case_management/add_design_card',
    name: '新增设计单',
    component: () => import('@/views/case_management/add_design_card.vue')
  },
  {
    path: '/case_management/talk',
    name: '会话框',
    component: () => import('@/views/case_management/talk.vue')
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/sign',
    name: '注册',
    component: () => import('@/views/login/sign.vue')
  },
  {
    path: '/reset',
    name: '忘记密码',
    component: () => import('@/views/login/reset.vue')
  },
  {
    path: '/case_list',
    name: '病例管理',
    component: () => import('@/views/case_list/index.vue')
  },
  {
    path: '/consultation_room',
    name: '会诊室',
    component: () => import('@/views/consultation_room/index.vue')
  },
  {
    path: '/consultation_detail',
    name: '会诊室详情',
    component: () => import('@/views/consultation_room/detail.vue')
  },
  {
    path: '/bill_center',
    name: '订单中心',
    component: () => import('@/views/bill_center/index.vue')
  },
  {
    path: '/news_center',
    name: '消息中心',
    component: () => import('@/views/news_center/index.vue')
  },
  {
    path: '/bill_center/detail',
    name: '订单详情',
    component: () => import('@/views/bill_center/detail.vue')
  },
  {
    path: '/consumables',
    name: '耗材商城',
    component: () => import('@/views/consumables/index.vue')
  },
  {
    path: '/consumables/detail/:id(\\d+)',
    name: '耗材商城详情',
    component: () => import('@/views/consumables/detail.vue')
  },
  {
    path: '/box',
    name: '百宝箱',
    component: () => import('@/views/box/index.vue')
  },
  {
    path: '/user_center',
    name: '个人中心',
    component: () => import('@/views/user_center/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
